import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Params, Router, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CredentialHeaderComponent } from './credential-header/header.component';
import { CredentialFooterComponent } from './credential-footer/credential-footer.component';
import { CampaignService } from '../../services/api/campaign.service';
import { CredentialsOneComponent } from '../../../components/credentials-design/credentials-one/credentials-one.component';
import { LandingPageService } from '../../services/store/landing-page.service';

@Component({
  selector: 'app-credential',
  templateUrl: './credential.component.html',
  styleUrls: ['./credential.component.css'],
  standalone: true,
  imports: [RouterOutlet, CredentialHeaderComponent,
    CredentialFooterComponent, CredentialsOneComponent]
})
export class CredentialComponent implements OnInit, OnDestroy {

  private _campaignService = inject(CampaignService);
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _document = inject(DOCUMENT);
  private _titleService = inject(Title);
  private landingStore = inject(LandingPageService);

  slug = "";
  showSecondView = false;

  //variables para header y footer
  headerBackground = '';
  headerTextColor = '';
  footerBackground = '';
  footerTextColor = '';
  logoCampaign = '';

  isLoaded = false;

  private previousTheme: string | null = null;

  constructor() {
  }

  ngOnInit() {
    const html = this._document.documentElement;
    this.previousTheme = html.dataset['coreuiTheme'] ?? null;
    html.dataset['coreuiTheme'] = 'light';

    this._route.params.subscribe((p: Params) => {
      this.slug = p['slug'];
      this.init();
    });
  }

  ngOnDestroy() {
    const html = this._document.documentElement;
    if (this.previousTheme) {
      html.dataset['coreuiTheme'] = this.previousTheme;
    } else {
      delete html.dataset['coreuiTheme'];
    }
  }

  ngAfterViewInit() {
    const loader = document.querySelector('.spinner-pag');
    if (loader) {
      loader.remove();
    }
  }

  init() {
    this._campaignService.getCampaignForSlug(this.slug).subscribe({
      next: (campaign: any) => {
        const data = campaign.data;
        console.log("Campaña", campaign);
        this.landingStore.setCampaign(data);

        const campaignName = data?.campaign?.name ?? data?.name ?? '';
        this._titleService.setTitle(campaignName ? `${campaignName} - Sharewave` : 'Sharewave');

        const landing = data.landing_page;

        // HEADER
        this.headerBackground = landing.header_bg_color;
        this.headerTextColor = landing.header_text_color ?? '#ffffff';
        this.logoCampaign = landing.header_logo;

        // FOOTER
        this.footerBackground = landing.footer_bg_color;
        this.footerTextColor = landing.footer_text_color ?? '#ffffff';

        this.isLoaded = true;
      },

      error: () => {
        this._router.navigate(['/admin/campaigns']);
      }
    });
  }

  handleGenerate() {
    this.showSecondView = true;
    const uuid = crypto.randomUUID();
    this._router.navigate([uuid], { relativeTo: this._route });
  }

  hideInitialLoader() {
    console.log("Escondiendo el loade");
    const loader = document.querySelector('.spinner-pag');
    if (loader) {
      (loader as HTMLElement).style.display = 'none';
    }
  }
}
